export default {"src":"/_next/static/media/sweet-potato.61ed75a8.svg","height":29,"width":84,"blurWidth":0,"blurHeight":0};